// global.service.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../environment';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  public domainApi: string = window.location.hostname;
  public globalPath: string = window.location.href; // Default path
  public slugBranchoffice: string = "slug";
  public passActivation: string = "activate";

  constructor(private router: Router) {
    const currentUrl = window.location.href; // Get the current URL
    const urlSegments = currentUrl.split('/'); // Split the URL into segments
    const desiredSegment = urlSegments[3]; // Extract the desired segment
    this.globalPath = desiredSegment;

    // set value domain api when localhost
    if(window.location.hostname == "localhost"){
      this.domainApi = environment.link_api_dev
    }else{
      this.domainApi = "/api/"
    }
  }

  setSlugBranchoffice(slug:string){
    this.slugBranchoffice = slug;
    localStorage.setItem('slugBranchoffice', slug);
  }

  getSlugBranchoffice(){
    let result_ = localStorage.getItem('slugBranchoffice');
    return result_;
  }

  setPassActivation(val:string){
    localStorage.setItem('passActivation', val);
  }

  getPassActivation(){
    let result_ = localStorage.getItem('passActivation');
    return result_;
  }

  getCompany() {
    let result_:any = localStorage.getItem('company');
    let companyObj = JSON.parse(result_);
    return companyObj;
  }

}

